<script setup lang="ts">
import { useSearchStore } from '@shared/global-store/stores/search'

import { CloseThinIcon } from '@fond-of/satch-icons'

const searchStore = useSearchStore()
</script>

<template>
  <div class="ml-2.5 h-[46px] sm:ml-5 sm:pl-0 md:h-[54px] lg:pr-0">
    <button
      class="inline-flex h-full items-center justify-center border-none bg-none text-black"
      type="button"
      @click="searchStore.toggleOpenState"
    >
      <CloseThinIcon class="size-6" />
    </button>
  </div>
</template>
